import React, { useState } from "react";
import { QuestWidget } from "./QuestWidget";

const GetStartedButton = ({ collectionId }: { collectionId: number }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  return (
    <QuestWidget
      collectionId={collectionId}
      dialog={true}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  );
};

export { GetStartedButton };
